import {useGetUsersSessions} from "api/api-hooks/user-hooks";
import {UserStatisticsApi} from "api/UserStatisticsApi";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import {easasAlert} from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import UserStatisticsDatatable
    from "components/pages/users-statistics-dashboard/components/user-statistics-datatable/UserStatisticsDatatable";
import UserStatisticsGanttChart
    from "components/pages/users-statistics-dashboard/components/users-statistics-gantt-chart/UsersStatisticsGanttChart";

import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import React, {useEffect, useState} from "react";
import {addToDate} from "utils/time-utils";


function generateCompanyListOptions(userSessionData: any[]) {
    const companyList = new Set();
    userSessionData.forEach((user: any) => {
        companyList.add(user.companyRef);
    });
    return Array.from(companyList).map((company) => {
        return {label: company, value: company};
    });
}

export function secondsToHms(d: number) {
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);


    const hDisplay = h > 0 ? h + "h " : "";
    const mDisplay = m > 0 ? m + "m " : "";

    return hDisplay + mDisplay;
}

const groupOptions = [
    {label: "User", value: "username"},
    {label: "Job Title", value: "jobTitle"},
];

const UsersStatisticsDashboard = () => {
    const [dateFrom, setDateFrom] = useState<Date>(addToDate(new Date(), -6, "HOURS"));
    const [dateTo, setDateTo] = useState<Date>(new Date());


    const [userSessionData, setUserSessionData] = useState<any[]>([]);
    const [selectedType, setSelectedType] = useState<string>("username");
    const [companyFilter, setCompanyFilter] = useState<string[]>();
    const [companyListOptions, setCompanyListOptions] = useState<any[]>([]);

    useGetUsersSessions(dateFrom.toISOString(), dateTo.toISOString(),  {
        refetchInterval: 10000,
        onSuccess: (data) => {
            setUserSessionData(data);
            setCompanyListOptions(generateCompanyListOptions(data));
        },
        onError: (error) => {
            easasAlert("error", `${error}`, "error");
        }
    });


    return (
        <div>
            <div className="flex justify-content-between align-items-center">
                <div className="flex gap-2 mb-2">
                    <div className="flex flex-column gap-2">
                        <label>Date from:</label>
                        <CalendarWrapper value={dateFrom} onChange={e => setDateFrom(e)}/>
                    </div>
                    <div className="flex flex-column gap-2">
                        <label>Date to:</label>
                        <CalendarWrapper value={dateTo} onChange={e => setDateTo(e)}/>
                    </div>
                </div>
                <div className="flex gap-2 ">
                    { companyListOptions.length > 1 && <div className="flex flex-column gap-2">
                        <label>Company: </label>
                        <MultiSelect
                            value={companyFilter}
                            placeholder="Select a Company"
                            options={companyListOptions}
                            onChange={e => setCompanyFilter(e.value)}
                            maxSelectedLabels={1}
                        />
                    </div>}
                    <div className="flex flex-column gap-2">
                        <label>Group By: </label>
                        <Dropdown value={selectedType} options={groupOptions} onChange={e => setSelectedType(e.value)}/>
                    </div>
                </div>
            </div>
            <UserStatisticsGanttChart data={userSessionData} selectedType={selectedType} companyFilter={companyFilter}/>
            <UserStatisticsDatatable userSessionData={userSessionData} selectedType={selectedType} companyFilter={companyFilter}/>
        </div>
    );
};

export default UsersStatisticsDashboard;